
import { Component, Vue, Prop } from "vue-property-decorator";
import CourseItem from "@/views/home/components/CourseItem.vue";
import OptionItem from "./components/OptionItem.vue";
import CollegeItem from "./components/CollegeItem.vue";
import BlmCourseItem from "@/views/home/components/BlmCourseItem.vue";
import { courseList, collegeList } from "@/apis/home";
@Component({
  components: {
    CourseItem,
    OptionItem,
    CollegeItem,
    BlmCourseItem
  }
})
export default class course extends Vue {
  total = 1;
  page = 1;
  per_page = 10;
  mustArr: any = [];
  optionArr: any = [];
  collegeArr: any = [];
  // 课程类型(1=MBA;2=EMBA)
  type: any = 2;
  //展示所有课程
  more = false;
  created() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    this.courseList(0);
    this.courseList(1);

    if (this.type == 2) {
      this.collegeList();
    }
  }
  handleType(key: any) {
    this.type = key;
    this.courseList(0);
    this.courseList(1);

    // this.collegeList();
    if (this.type == 2) {
      this.collegeList();
    }
  }
  // 必修
  async courseList(key: any) {
    const { data, total } = await courseList({
      f: this.type,
      m: key,
      per_page: key == 1 ? 999 : 8
    });
    if (key == 1) {
      this.mustArr = data;
    } else {
      this.optionArr = data;
      // 超过8门显示
      this.more = total <= 8;
    }
  }
  //光华商学
  async collegeList() {
    const { data } = await collegeList({});
    this.collegeArr = data;
  }
  // 查看全部
  async handleMore() {
    this.more = true;
    const { data } = await courseList({
      f: this.type,
      m: 0,
      per_page: 999
    });
    this.optionArr = data;
  }
}
